import { useCallback, useState } from 'react';
const useAccordionOpenState = ({
  storageKey,
  getInitialOpenState
}) => {
  let storedOpenState = null;
  try {
    storedOpenState = window.localStorage.getItem(storageKey);
  } catch (error) {
    console.error({
      message: 'Error setting local storage item',
      storageKey,
      error
    });
  }
  const [isOpen, setIsOpen] = useState(getInitialOpenState(storedOpenState));
  const handleOpenChange = useCallback(() => {
    try {
      window.localStorage.setItem(storageKey, (!isOpen).toString());
    } catch (error) {
      console.error({
        message: 'Error setting local storage item',
        storageKey,
        error
      });
    }
    setIsOpen(!isOpen);
  }, [isOpen, storageKey]);
  return {
    isOpen,
    handleOpenChange
  };
};
export default useAccordionOpenState;